import type { AuthPhysician } from "@elation/api-client/src/stitch-web/models";

import { useActor, useAssertActor } from "@src/shared/providers/actorProvider";

export function useCurrentPhysician(): AuthPhysician {
  return useAssertActor("physician").user;
}

export function usePhysicianId(): number {
  return useCurrentPhysician().id;
}

export function useIsPhysician(): boolean {
  return useActor().type === "physician";
}
